export function WeatherCard({ day }) {
  const dt = new Date(day.date + 'T12:00:00');
  const dayLabel = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][dt.getDay()];
  const md = day.date.slice(5).replace('-', '-'); // MM-DD
  const [_, __, emoji] = (() => {
    // Re-compute from weather_code so we don't rely on the server keeping the emoji.
    const map = {
      0:'☀️',1:'☀️',2:'⛅',3:'☁️',45:'🌫',48:'🌫',
      51:'🌦',53:'🌦',55:'🌦',56:'🌦',57:'🌦',
      61:'🌧',63:'🌧',65:'🌧',66:'🌧',67:'🌧',
      71:'❄️',73:'❄️',75:'❄️',77:'❄️',
      80:'🌧',81:'🌧',82:'🌧',85:'❄️',86:'❄️',
      95:'⛈',96:'⛈',99:'⛈',
    };
    return ['', '', map[day.weather_code] || '🌤'];
  })();
  return (
    <div style={{
      minWidth: 0,
      background: '#fafafa', border: '1px solid var(--rule)', borderRadius: 8,
      padding: 6, textAlign: 'center',
    }}>
      <div style={{ fontSize: 11, fontWeight: 700, color: '#212121' }}>{dayLabel}</div>
      <div style={{ fontSize: 10, color: '#757575' }}>{md}</div>
      <div style={{ fontSize: 20, margin: '2px 0' }}>{emoji}</div>
      <div style={{ fontSize: 14, fontWeight: 700, color: '#212121' }}>{day.temp_high}°</div>
      <div style={{ fontSize: 11, color: '#757575' }}>{day.temp_low}°</div>
      {day.precipitation_pct > 0 && (
        <div style={{ fontSize: 10, color: '#1565c0', fontWeight: 600, marginTop: 1 }}>{day.precipitation_pct}%</div>
      )}
    </div>
  );
}
